import _ from 'lodash';
import React from 'react';
import FeedContainerSmall from '../NewsFeed/FeedContainerSmall.jsx';
import SideScrollableContainer from '../Video/SideScrollableContainer.jsx';
import { appContext } from '../../util/decorators';

@appContext
export default class VideoSummaries extends React.PureComponent {
  render() {
    const { country, summaries } = this.props;
    const filteredSummaries = _.filter(summaries, (videoPost) => videoPost && !_.isEmpty(videoPost));

    const heading = _.get(summaries, `[0].tags.competitions[0].${country}.name`);

    if (!filteredSummaries.length) {
      return null;
    }

    return (
        <span>
        </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/VideoSummaries.jsx